import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClusterService {
  private visitorApiUrl = `${environment.baseUrl.replace('/v1/', '/api/v1/')}visitor-management/`;

  constructor(private http: HttpClient) {}

  getClusters(page: number = 1, pageSize: number = 200): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    return this.http.get(`${this.visitorApiUrl}clusters/`, { params });
  }

  getCluster(id: number): Observable<any> {
    return this.http.get(`${this.visitorApiUrl}clusters/${id}/`);
  }

  createCluster(payload: any): Observable<any> {
    return this.http.post(`${this.visitorApiUrl}clusters/`, payload);
  }

  updateCluster(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.visitorApiUrl}clusters/${id}/`, payload);
  }

  deleteCluster(id: number): Observable<any> {
    return this.http.delete(`${this.visitorApiUrl}clusters/${id}/`);
  }

  listClusterValues(clusterId: number, page: number = 1, pageSize: number = 200): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('cluster_id', clusterId.toString());
    return this.http.get(`${this.visitorApiUrl}cluster-values/`, { params });
  }

  createClusterValue(payload: any): Observable<any> {
    return this.http.post(`${this.visitorApiUrl}cluster-values/`, payload);
  }

  updateClusterValue(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.visitorApiUrl}cluster-values/${id}/`, payload);
  }

  deleteClusterValue(id: number): Observable<any> {
    return this.http.delete(`${this.visitorApiUrl}cluster-values/${id}/`);
  }
}
